import { GeneralModel } from "./general.model";

export class Formula extends GeneralModel {
}